
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/futures",
      function () {
        return require("private-next-pages/futures/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/futures"])
      });
    }
  